import { render, staticRenderFns } from "./inflowIndexRenovation.vue?vue&type=template&id=000306d4&scoped=true"
import script from "./inflowIndexRenovation.vue?vue&type=script&lang=js"
export * from "./inflowIndexRenovation.vue?vue&type=script&lang=js"
import style0 from "./inflowIndexRenovation.vue?vue&type=style&index=0&id=000306d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000306d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000306d4')) {
      api.createRecord('000306d4', component.options)
    } else {
      api.reload('000306d4', component.options)
    }
    module.hot.accept("./inflowIndexRenovation.vue?vue&type=template&id=000306d4&scoped=true", function () {
      api.rerender('000306d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mallManagement/indexRenovation/inflowIndexRenovation.vue"
export default component.exports